import { ReactComponent as MessageIcon } from './message.svg';

export default MessageIcon;
